import React from "react";
import styled from "styled-components";
import { Transfer } from "../components/atoms/Transfer";
import { ResultColumn } from "../components/atoms/ResultColumn";
import { Breadcrumbs } from "../components/atoms/Breadcrumbs";
import { formatBalance } from "../utils/formatters";
import { HeaderWithBack } from "../components/molecules/Header";
import { Button } from "../components/atoms/Button";

const Container = styled.div`
  width: 80%;
`;

const TransfersContainer = styled.div`
  margin: 3rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: stretch;
`;

const TransferContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  min-height: 4rem;
`;

export const Results = ({
  statistics,
  handleBackButtonClicked,
  handleResetButtonClicked,
}) => {
  const transfersByPayer = Object.entries(
    statistics.transfers.reduce(
      (ret, transfer) => ({
        ...ret,
        [transfer.from]: [...(ret[transfer.from] || []), transfer],
      }),
      {}
    )
  );

  return (
    <Container>
      <HeaderWithBack handleBackButtonClicked={handleBackButtonClicked}>
        <h3>Podział Zysków: </h3>
      </HeaderWithBack>
      <Breadcrumbs>
        Kliknij kafelek z nickiem gracza, aby skopiować tekst dla bankiera
      </Breadcrumbs>
      <TransfersContainer>
        {transfersByPayer.map(([payerName, transfers], payerIndex) => (
          <ResultColumn
            title={payerName}
            transfers={transfers}
            key={payerIndex}
          >
            {transfers.map((transfer, transferIndex) => (
              <TransferContainer key={transferIndex}>
                <Transfer transfer={transfer} />
              </TransferContainer>
            ))}
          </ResultColumn>
        ))}
      </TransfersContainer>
      <Breadcrumbs>
        Zysk na gracza: {formatBalance(statistics.profitPerPlayer)}
      </Breadcrumbs>
      <br />
      <Breadcrumbs>
        Całkowity zysk: {formatBalance(statistics.total)}
      </Breadcrumbs>
      <br />
      <br />
      <Button handleClick={handleResetButtonClicked}>Od nowa</Button>
    </Container>
  );
};
